
import "./WeatherForecast.css";
import axios from "axios";
import { useState, useEffect } from "react";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);

  useEffect(()=>{
    setLoaded(false);
  }, [props.coordinates])


  

  function handleResponse(response) {
    setForecast(response.data.daily);
    setLoaded(true);
  }
  function load(){
     let lon = props.coordinates.lon;
     let lat = props.coordinates.lat;
     let apiKey = "eae061c95483dd066657bfc7525418ed";
     let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric`;

     axios.get(apiUrl).then(handleResponse);
     return null;
  }

  if (loaded) {
    return (
      <div className="WeatherForecast mt-3 mb-2">
        <div className="row">
          {forecast.map(function (dailyForecast, index) {
          if (index < 5) {
           
           return (
              <div className="col" key={index}>
                <WeatherForecastDay data={dailyForecast} />
              </div>
            );
           }else{
            return null;
           }
          })}
        </div>
      </div>
    );
  } else {
   load();
  }
}
